(() => {
  class DrawerDelay {
    constructor(delay, pending = null) { this.delay = delay * 1000; this.pending = pending; }
    added(productId, drawerOpen, now) { this.pending = { productId, sawDrawer: drawerOpen, readyAt: null, addedAt: now }; }
    observe(drawerOpen, now) {
      if (!this.pending) return;
      if (drawerOpen) { this.pending.sawDrawer = true; this.pending.readyAt = null; }
      else if (this.pending.sawDrawer && this.pending.readyAt === null) this.pending.readyAt = now + this.delay;
    }
    due(now) { return !!this.pending && this.pending.readyAt !== null && now >= this.pending.readyAt; }
  }
  window.STDComplementaryTiming = DrawerDelay;
  function cartObserver() {
    if (window.STDCartAddObserver) return window.STDCartAddObserver;
    const observer = { listeners: new Set(), suppress: false };
    const originalFetch = window.fetch;
    window.fetch = function (input, options) {
      const result = originalFetch.apply(this, arguments);
      let isAdd = false;
      try { isAdd = /\/cart\/add(?:\.js)?\/?$/.test(new URL(typeof input === 'string' ? input : input.url, window.location.origin).pathname); } catch (_) {}
      if (isAdd && observer.listeners.size && !observer.suppress) result.then(response => {
        if (response.ok) response.clone().json().then(data => { for (const listener of observer.listeners) listener(data); }).catch(() => {});
      }).catch(() => {});
      return result;
    };
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      let isAdd = false;
      try { isAdd = /\/cart\/add(?:\.js)?\/?$/.test(new URL(url, window.location.origin).pathname); } catch (_) {}
      if (isAdd) this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) return;
        try { const data = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); for (const listener of observer.listeners) listener(data); } catch (_) {}
      }, { once: true });
      return originalOpen.apply(this, arguments);
    };
    window.STDCartAddObserver = observer;
    return observer;
  }
  let cleanup;
  function init() {
    if (cleanup) cleanup();
    const root = document.querySelector('[data-pair-slideout]');
    if (!root) return;
    root.hidden = true;
    root.classList.remove('std-pair-open');
    root.querySelector('[data-pair-panel]').hidden = true;
    root.querySelector('[data-pair-tab]').hidden = true;
    const config = JSON.parse(root.querySelector('[data-pair-config]').textContent);
    if (!config.enabled && !(config.editor && config.preview)) return;
    const panel = root.querySelector('[data-pair-panel]');
    const tab = root.querySelector('[data-pair-tab]');
    const products = root.querySelector('[data-pair-products]');
    const message = root.querySelector('[data-pair-status]');
    const closeButton = root.querySelector('[data-pair-close]');
    const dismissButton = root.querySelector('[data-pair-dismiss]');
    const key = 'std-pair:' + config.campaign;
    let disposed = false, shown = false, candidates = null, loading = null, generation = 0, opening = false;
    let pending = null, lastAdd = 0, ownAdding = false;
    try { shown = sessionStorage.getItem(key + ':shown') === 'true'; pending = JSON.parse(sessionStorage.getItem(key + ':pending')); } catch (_) {}
    const timing = new DrawerDelay(config.delay, pending);
    const drawerOpen = () => document.body.classList.contains('show-cart-summary');
    const eligible = () => config.frequency !== 'session' || !shown;
    const blocked = () => drawerOpen() || document.body.classList.contains('show-mobile-nav') || document.body.classList.contains('template-cart') || document.visibilityState !== 'visible' || !!document.querySelector('[data-event-panel]:not([hidden]), [data-promo-panel]:not([hidden])');
    root.dataset.pairState = 'idle';
    function persist() {
      root.dataset.pairState = timing.pending ? (timing.pending.readyAt === null ? 'waiting-for-cart-close' : 'waiting-for-delay') : (shown ? 'shown' : 'idle');
      if (config.editor) return;
      try { if (timing.pending) sessionStorage.setItem(key + ':pending', JSON.stringify(timing.pending)); else sessionStorage.removeItem(key + ':pending'); } catch (_) {}
    }
    function close() { root.classList.remove('std-pair-open'); panel.hidden = true; tab.hidden = !products.children.length; }
    function open(manual = false) {
      root.hidden = false; panel.hidden = false; tab.hidden = true;
      requestAnimationFrame(() => { if (!disposed && !panel.hidden) root.classList.add('std-pair-open'); });
      if (!config.editor) { shown = true; timing.pending = null; persist(); try { sessionStorage.setItem(key + ':shown', 'true'); } catch (_) {} }
      if (manual) closeButton.focus();
    }
    function render(cart) {
      const inCart = new Set(cart.items.map(item => String(item.product_id)));
      const displayed = new Set();
      products.replaceChildren();
      if (candidates) {
        for (const card of candidates.querySelectorAll('[data-pair-card]')) {
          const id = card.dataset.productId;
          if ((!config.editor && inCart.has(id)) || displayed.has(id)) continue;
          products.append(card.cloneNode(true)); displayed.add(id);
          if (displayed.size >= config.limit) break;
        }
      }
      root.hidden = !displayed.size && !config.editor;
      tab.hidden = !displayed.size || !panel.hidden;
      if (!displayed.size && !config.editor) close();
      if (config.editor) message.textContent = displayed.size ? '' : config.empty;
      return displayed.size;
    }
    async function getCart() {
      const response = await fetch(config.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      return response.json();
    }
    function load(productId) {
      root.dataset.pairLoad = 'loading';
      const token = ++generation;
      loading = (async () => {
        try {
          const cart = await getCart();
          let template = root.querySelector('[data-pair-candidates]');
          if (config.source === 'shopify') {
            if (!productId) { candidates = null; render(cart); return 0; }
            const url = new URL(config.recommendUrl, window.location.origin);
            url.searchParams.set('section_id', config.sectionId);
            url.searchParams.set('product_id', productId);
            url.searchParams.set('limit', '10');
            url.searchParams.set('intent', 'complementary');
            const response = await fetch(url.toString());
            if (!response.ok) throw new Error('recommendations');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            template = html.querySelector('[data-pair-candidates]');
          }
          if (config.source === 'rules') {
            const item = cart.items.find(item => String(item.product_id) === String(productId));
            const productUrl = config.editor ? config.previewUrl : item?.url;
            if (productUrl) {
              const url = new URL(productUrl, window.location.origin);
              url.search = '';
              url.searchParams.set('section_id', config.sectionId);
              const response = await fetch(url.toString());
              if (!response.ok) throw new Error('rules');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              template = html.querySelector('[data-pair-candidates]');
            } else if (!config.editor) {
              template = null;
            }
          }
          if (disposed || token !== generation) return 0;
          candidates = template ? template.content.cloneNode(true) : null;
          root.dataset.pairLoad = 'loaded';
          return render(cart);
        } catch (_) {
          root.dataset.pairLoad = 'failed';
          if (!disposed && token === generation) { candidates = null; products.replaceChildren(); root.hidden = !config.editor; if (config.editor) message.textContent = config.empty; }
          return 0;
        }
      })();
      return loading;
    }
    function added(data) {
      if (config.editor || !eligible() || ownAdding) return;
      const items = Array.isArray(data?.items) ? data.items : [data];
      const item = items.find(item => item && item.product_type !== 'mws_fee_generated' && !/^additional fees$/i.test(item.product_title || item.title || ''));
      if (!item?.product_id || item.quantity === 0) return;
      const now = Date.now();
      if (now - lastAdd < 500 && timing.pending?.productId === item.product_id) return;
      lastAdd = now;
      close();
      timing.added(item.product_id, drawerOpen(), now); persist();
      load(item.product_id);
    }
    function onAdded(event) { if (event.detail?.origin !== 'complementary-slideout') added(event.detail); }
    function onAjax(_event, xhr, settings) {
      try {
        const path = new URL(settings.url, window.location.origin).pathname;
        if (!/\/cart\/add(?:\.js)?\/?$/.test(path) || xhr.status < 200 || xhr.status >= 300) return;
        added(xhr.responseJSON || JSON.parse(xhr.responseText));
      } catch (_) {}
    }
    async function attemptOpen() {
      if (opening) return;
      opening = true;
      const active = timing.pending;
      try {
        if (loading) await loading;
        const cart = await getCart();
        if (disposed || timing.pending !== active || blocked() || !eligible() || !timing.due(Date.now())) return;
        if (cart.item_count && render(cart)) open();
        else { timing.pending = null; persist(); }
      } catch (_) { timing.pending = null; persist(); }
      finally { opening = false; }
    }
    function tick() {
      if (disposed || config.editor) return;
      if ((drawerOpen() || document.querySelector('[data-event-panel]:not([hidden]), [data-promo-panel]:not([hidden])')) && !panel.hidden) close();
      if (!eligible()) { timing.pending = null; persist(); return; }
      const previous = JSON.stringify(timing.pending);
      timing.observe(drawerOpen(), Date.now());
      if (JSON.stringify(timing.pending) !== previous) persist();
      if (timing.due(Date.now()) && !blocked()) attemptOpen();
    }
    function manualOpen() { if (!blocked() && products.children.length) open(true); }
    function manualClose() { close(); if (!tab.hidden) tab.focus(); }
    function onKey(event) { if (event.key === 'Escape' && !panel.hidden) manualClose(); }
    async function submit(event) {
      const form = event.target.closest('[data-pair-product-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button.disabled) return;
      button.disabled = true; ownAdding = true;
      const label = button.textContent; button.textContent = config.adding; message.textContent = '';
      try {
        observerAdds.suppress = true;
        let request;
        try { request = fetch(config.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } }); } finally { observerAdds.suppress = false; }
        const response = await request;
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || config.error);
        message.textContent = config.added;
        if (window.theme && typeof window.theme.updateCartSummaries === 'function') window.theme.updateCartSummaries(false, true, false);
        document.dispatchEvent(new CustomEvent('std:cart-updated', { detail: { ...data, origin: 'complementary-slideout' } }));
        const card = form.closest('[data-pair-card]'); card.remove();
        if (!products.children.length) close();
      } catch (error) { message.textContent = error.message || config.error; }
      finally { ownAdding = false; button.textContent = label; button.disabled = false; }
    }
    function change(event) {
      if (event.target.matches('[data-pair-variant]')) event.target.closest('[data-pair-card]').querySelector('[data-pair-price]').textContent = event.target.selectedOptions[0].dataset.price;
    }
    const observerAdds = cartObserver();
    observerAdds.listeners.add(added);
    const jq = window.jQuery;
    if (jq) jq(document).on('ajaxSuccess.stdPair', onAjax);
    document.addEventListener('std:cart-updated', onAdded);
    document.addEventListener('keydown', onKey);
    root.addEventListener('submit', submit); root.addEventListener('change', change);
    tab.addEventListener('click', manualOpen); closeButton.addEventListener('click', manualClose); dismissButton.addEventListener('click', manualClose);
    const observer = new MutationObserver(tick); observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const interval = setInterval(tick, 250);
    if (config.editor) {
      load(config.seed).then(() => { if (!disposed && config.preview) open(); });
    } else if (timing.pending && eligible()) { load(timing.pending.productId); tick(); }
    cleanup = () => {
      observerAdds.listeners.delete(added);
      disposed = true; generation++; observer.disconnect(); clearInterval(interval);
      if (jq) jq(document).off('ajaxSuccess.stdPair', onAjax);
      document.removeEventListener('std:cart-updated', onAdded); document.removeEventListener('keydown', onKey);
      root.removeEventListener('submit', submit); root.removeEventListener('change', change);
      tab.removeEventListener('click', manualOpen); closeButton.removeEventListener('click', manualClose); dismissButton.removeEventListener('click', manualClose);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();

